import { getBlob, getBytes, ref } from 'firebase/storage'

import { getFirebaseStorage } from '@/lib/firebase/app'
import { memoised } from '@/lib/templates/memoised'
import type { TemplateFiles } from '@/lib/templates/template-files'

const PREFIX = 'templates/'

/** The template bundle in the project's Storage bucket under `templates/`, each path read once. */
export function storageTemplateFiles(): TemplateFiles {
  const objectRef = (path: string) => ref(getFirebaseStorage(), `${PREFIX}${path}`)
  return {
    readText: memoised(async (path) => new TextDecoder().decode(await getBytes(objectRef(path)))),
    readObjectUrl: memoised(async (path) => URL.createObjectURL(await getBlob(objectRef(path)))),
  }
}
